@use "../../styles/breakpoint.module.scss" as *;

.gridAsymmetric {
    display: grid;
    grid-template-columns: 7fr 5fr;
    gap: var(--spacer-24);
    align-items: start;

    @media ($below-mobile) {
        grid-template-columns: 1fr;
        gap: var(--spacer-32);
    }
}

.gridSymmetric {
    display: flex;
    gap: var(--spacer-24);
    justify-content: center;

    > * {
        flex: 0 1 553px;
    }

    @media ($below-mobile) {
        flex-direction: column;

        > * {
            flex: none;
            width: 100%;
        }
    }
}
